import React, { FC, useState } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { useDispatch } from "react-redux";
import { connectMindbodyAction } from "../../../actions/business";
import { checkuser } from "../../../actions/user";

interface MindbodyFormValues {
  siteId: string;
}

interface MindbodyConnectModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const MindbodyConnectModal: FC<MindbodyConnectModalProps> = ({
  open,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm<MindbodyFormValues>();
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleSubmit = (values: MindbodyFormValues) => {
    const { siteId } = values;

    setLoading(true); // START loader

    dispatch(
      connectMindbodyAction({ siteId }, (resp: any) => {
        setLoading(false); // ALWAYS STOP loader
        onClose(); // close modal
        if (resp?.status === 200) {
          const activationLink = resp?.activationLink;

          dispatch(
            checkuser((res: any) => {
              if (res?.status === 200) {
                form.resetFields();
                // onClose(); // close modal
              }
            })
          );

          if (activationLink) {
            window.open(activationLink, "_blank");
          }
        } 
      })
    );
  };

  return (
    <Modal
      title="Connect Mindbody"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
    >
      <Form<MindbodyFormValues>
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Site ID"
          name="siteId"
          rules={[
            { required: true, message: "Enter Site ID" },
            {
              pattern: /^\d+$/,
              message: "Site ID must be numeric",
            },
          ]}
        >
          <Input placeholder="Enter your Mindbody Site ID" />
        </Form.Item>

        {/* Helpful UX */}
        <p style={{ fontSize: "12px", color: "#888", marginTop: "-10px" }}>
          You can find your Site ID in your Mindbody URL (e.g., studioid=123456)
        </p>

        <div className="text-end btn-groups-Forms">
          <Button
            onClick={onClose}
            className="btn btn-outline-primary"
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="btn btn-primary"
          >
            Connect
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default MindbodyConnectModal;